import translationKeys from '@translationKeys'

import { HistoryFilterOptions, ProfileType, SortOrder, SortType } from '../types'

export const FILTER_KEYS = {
  TITLE: 'title',
  COMPANY_NAME: 'company_name',
  DEPARTMENT: 'department',
  COUNTRY: 'country',
  STATE: 'state',
  CITY: 'city',
  COMPANY: 'company',
  DELEGATE: 'delegate',
  BIOTECH: 'biotech',
  MEDTECH: 'medtech',
  TECHNOLOGIES: 'technologies',
  SERVICES: 'services',
  CATEGORY_SECTOR: 'category_sector',
  CATEGORY_SUB_SECTOR: 'category_sub_sector',
  MILESTONE: 'milestone',
  DIFFERENTIATOR: 'differentiator',
}

export const PROFILE_TYPES: Record<string, ProfileType> = {
  COMPANY: ProfileType.company,
  BIOTECH: ProfileType.biotech,
  MEDTECH: ProfileType.medtech,
  TECHNOLOGIES: ProfileType.technologies,
  SERVICES: ProfileType.services,
  DELEGATE: ProfileType.delegate,
}

export const PROFILE_FILTERS_ORDER = {
  [PROFILE_TYPES.COMPANY]: 1,
  [PROFILE_TYPES.BIOTECH]: 2,
  [PROFILE_TYPES.MEDTECH]: 3,
  [PROFILE_TYPES.TECHNOLOGIES]: 4,
  [PROFILE_TYPES.SERVICES]: 5,
  [PROFILE_TYPES.DELEGATE]: 6,
}

export const getDefaultSearchableProfilesState = (value = true) =>
  Object.values(PROFILE_TYPES).reduce((acc, i) => ({ ...acc, [i]: value }), {} as Record<ProfileType, boolean>)

export const PROFILE_TYPE_LABELS = {
  [PROFILE_TYPES.COMPANY]: 'Company',
  [PROFILE_TYPES.DELEGATE]: 'Person',
  [PROFILE_TYPES.BIOTECH]: 'Biotech/Pharma Products',
  [PROFILE_TYPES.MEDTECH]: 'Medtech products',
  [PROFILE_TYPES.TECHNOLOGIES]: 'Technologies',
  [PROFILE_TYPES.SERVICES]: 'Services',
}

export const FILTER_LABELS_MAP = {
  [FILTER_KEYS.TITLE]: 'Title',
  [FILTER_KEYS.COMPANY_NAME]: 'Company Name',
  [FILTER_KEYS.DEPARTMENT]: 'Department',
  [FILTER_KEYS.COUNTRY]: 'Country',
  [FILTER_KEYS.STATE]: 'State',
  [FILTER_KEYS.CITY]: 'City',
  [FILTER_KEYS.COMPANY]: 'Company',
  [FILTER_KEYS.DELEGATE]: 'Person',
  [FILTER_KEYS.BIOTECH]: 'Biotech/Pharma Products',
  [FILTER_KEYS.MEDTECH]: 'Medtech products',
  [FILTER_KEYS.TECHNOLOGIES]: 'Technologies',
  [FILTER_KEYS.SERVICES]: 'Services',
  [FILTER_KEYS.CATEGORY_SECTOR]: 'Category Sector',
  [FILTER_KEYS.CATEGORY_SUB_SECTOR]: 'Category Sub Sector',
  [FILTER_KEYS.MILESTONE]: 'Milestone',
  [FILTER_KEYS.DIFFERENTIATOR]: 'Differentiator',
}

export const DEFAULT_PAGE_LIMIT = 20

export const NEW_HIGHLIGHT_MAX_DEPTH = 1000

export const SORT_SEARCH_OPTIONS = [
  {
    id: 1,
    label: translationKeys.SORT_TEXT_BOTTOM,
    data: { type: SortType.text, order: SortOrder.asc },
  },
  {
    id: 2,
    label: translationKeys.SORT_TEXT_UP,
    data: { type: SortType.text, order: SortOrder.desc },
  },
  {
    id: 3,
    label: translationKeys.SORT_MOST_RECENT,
    data: { type: SortType.date, order: SortOrder.desc },
  },
  {
    id: 4,
    label: translationKeys.SORT_LEAST_RECENT,
    data: { type: SortType.date, order: SortOrder.asc },
  },
]

export const HISTORY_FILTER_OPTIONS = [
  {
    id: HistoryFilterOptions.MY_MEETINGS,
    label: translationKeys.SEARCH_HISTORY_FILTER_MY_MEETINGS,
    data: { exclude: false, onlyMine: true },
  },
  {
    id: HistoryFilterOptions.PERSONAL_HISTORY,
    label: translationKeys.SEARCH_HISTORY_FILTER_MY_MEETINGS,
    data: { exclude: false, onlyMine: false, hasAttended: true },
  },
  {
    id: HistoryFilterOptions.COMPANY_MEETINGS,
    label: translationKeys.SEARCH_HISTORY_FILTER_COMPANY_HISTORY,
    data: { exclude: false, onlyMine: undefined },
  },
  {
    id: HistoryFilterOptions.NO_HISTORY,
    label: translationKeys.SEARCH_HISTORY_FILTER_NO_HISTORY,
    data: { exclude: true, onlyMine: undefined },
  },
]

export const SEARCH_GROUP_BY_OPTIONS = [
  {
    id: 1,
    label: translationKeys.GROUP_BY_COMPANY,
    value: ProfileType.company,
  },
]

export const DEFAULT_SORT_OPTION = SORT_SEARCH_OPTIONS[0]

export const FILTER_SECTION_REQUIRES_SEARCH = 'country_states'
export const GENERIC_FILTER_SELECT_LIMIT = 13
export const MAX_PROSPECTS_TO_ADD_TO_SHORTLIST = 500
